// src/utils/toast.ts
import Swal from "sweetalert2";

export const showErrorToast = (message: string) => {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon: "error",
    text: message,
    showConfirmButton: false,
    timer: 3000,
  });
};

export const showSuccessToast = (message: string) => {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon: "success",
    text: message,
    showConfirmButton: false,
    timer: 3000,
  });
};